import {
  arrow,
  autoUpdate,
  FloatingArrow,
  FloatingOverlay,
  FloatingPortal,
  offset,
  shift,
  size,
  useFloating,
} from '@floating-ui/react'
import classnames from 'classnames'
import React, { PropsWithChildren, useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { useModalContext } from '../Modal/Modal'

import styles from './Popup.module.scss'

type PopupProps = PropsWithChildren<{
  open: boolean
  onRequestClose: () => void
  menu?: boolean
  className?: string
}>

export default React.memo(function Popup({ open, onRequestClose, menu, className, children }: PopupProps) {
  const modelContext = useModalContext()

  const arrowRef = useRef(null)
  const { refs, floatingStyles, context } = useFloating({
    placement: 'bottom',
    whileElementsMounted: autoUpdate,
    middleware: [
      shift(),
      size({
        padding: { bottom: 20 },
        apply({ availableHeight, elements }) {
          elements.floating.style.maxHeight = `${availableHeight}px`
        },
      }),
      arrow({
        element: arrowRef,
      }),
      offset(30),
    ],
  })

  const location = useLocation()

  const classNames = classnames(
    styles.Popup,
    {
      [styles.menu]: menu,
    },
    className
  )

  useEffect(() => {
    if (open) {
      onRequestClose()
    }
  }, [location])

  return (
    <div ref={refs.setReference}>
      <FloatingPortal preserveTabOrder={false} id={modelContext.id}>
        {open && (
          <>
            <FloatingOverlay className={styles.backdrop} onClick={onRequestClose} />
            <div ref={refs.setFloating} className={classNames} style={floatingStyles}>
              {children}
              <FloatingArrow ref={arrowRef} context={context} fill="white" height={20} width={50} tipRadius={1} />
            </div>
          </>
        )}
      </FloatingPortal>
    </div>
  )
})
